import type { BaseResponse } from 'widget/types/api';

import type { UploadAttachmentResponse } from '../ApiStore/types';

export const MAX_FILE_SIZE = 30 * 1024 * 1024; // 30 MB

export const MAX_ATTACHMENTS_PER_MESSAGE = 10;

export const PREVIEW_MIME_TYPES = [
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/webp'
];

export enum AttachmentStatus {
  READY = 'ready',
  UPLOADING = 'uploading',
  ERROR = 'error'
}

export enum AttachmentErrorCode {
  fileTooLarge = 'file_too_large',
  uploadFailed = 'upload_failed'
}

export const attachmentErrorMessages: Record<AttachmentErrorCode, string> = {
  [AttachmentErrorCode.fileTooLarge]: 'Размер файла превышает 30 МБ',
  [AttachmentErrorCode.uploadFailed]: 'Не удалось загрузить файл'
};

export const attachmentErrorToast: Record<AttachmentErrorCode, string> = {
  [AttachmentErrorCode.fileTooLarge]:
    'Слишком большой размер файла - загрузите файл до 30 МБ',
  [AttachmentErrorCode.uploadFailed]:
    'Не удалось загрузить файл - попробуйте еще раз'
};

export const ATTACHMENTS_LIMIT_TOAST = `К сообщению можно прикрепить не более ${MAX_ATTACHMENTS_PER_MESSAGE} файлов`;

export const backendErrorCodes = {
  ENTITY_TOO_BIG: 'entity_too_big'
} as const;

export interface Attachment {
  id: string;
  file: File;
  name: string;
  size: number;
  mimeType: string;
  status: AttachmentStatus;
  error?: string;
  errorCode?: AttachmentErrorCode;
  previewUrl?: string;
  width?: number;
  height?: number;

  serverAttachmentId?: string;
  serverUrl?: string;
  serverPreviewUrl?: string;
}

export type UploadAttachmentFn = (
  file: File,
  signal?: AbortSignal
) => Promise<BaseResponse<UploadAttachmentResponse>>;

export type OnErrorFn = (message: string) => void;
